import { Alert, Button, Link, Stack, TextField, Typography } from '@mui/material';
import { CenteredFormPage } from 'components/CenteredFormPage';
import { LinkButton } from 'components/shared/LinkButton';
import { observer } from 'mobx-react-lite';
import { KeyboardEvent } from 'react';
import { useRootStore } from 'stores/RootStore';

const ResetPasswordEmailPage = observer(() => {
  const { routeStore, resetPasswordEmailStore } = useRootStore();
  const { navigateByName } = routeStore;
  const { form, message, status, sendEmail } = resetPasswordEmailStore;

  const handleKeyInField = (evt: KeyboardEvent) => {
    if (evt.key === 'Enter') {
      evt.stopPropagation();
      evt.preventDefault();
      if (form.isValid) {
        sendEmail();
      }
    }
  };

  const renderContent = () => {
    if (status === 'success') {
      return (
        <>
          <Typography variant="h5" textAlign="center">
            <strong>Email Sent</strong>
          </Typography>
          <Typography variant="body1" textAlign="center">
            We've sent an email to {form.$('email').value} with a link to reset your password.
          </Typography>
          <Button variant="contained" disableElevation style={{ height: 56 }} onClick={() => navigateByName('login')}>
            Back to Log In
          </Button>
        </>
      );
    } else {
      return (
        <>
          <Typography variant="h5" textAlign="center">
            <strong>Forgot Password?</strong>
          </Typography>
          {message && (
            <Alert aria-label="form-error" severity={status === 'error' ? 'error' : 'success'}>
              {message}
              {status === 'error' && (
                <>
                  {'\n'}
                  For assistance, reach out to us at{' '}
                  <Link href="mailto:support@boweryvaluation.com">support@boweryvaluation.com</Link>.
                </>
              )}
            </Alert>
          )}
          <TextField
            variant="outlined"
            autoComplete="off"
            onKeyDown={handleKeyInField}
            data-testid="email"
            required
            {...form.$('email').bind()}
          />
          <Button
            variant="contained"
            disableElevation
            style={{ height: 56 }}
            disabled={!form.isValid}
            onClick={() => sendEmail()}
          >
            Request a reset link
          </Button>
          <Typography variant="body1" alignSelf="center" color="text.secondary" style={{ marginTop: '32px' }}>
            Don't have an account?{' '}
            <LinkButton onClick={() => navigateByName('register')}>Create an account.</LinkButton>
          </Typography>
        </>
      );
    }
  };

  return (
    <CenteredFormPage aria-label="forgot password page" onBack={() => navigateByName('login')}>
      <form autoComplete="off">
        <Stack spacing={4}>{renderContent()}</Stack>
      </form>
    </CenteredFormPage>
  );
});

export { ResetPasswordEmailPage };
